<template>
  <div class="avatar-cropper">
    <el-upload
      ref="upload"
      :action="''"
      :show-file-list="false"
      :on-change="changeAvatar"
      :auto-upload="false"
    >
      <el-button
        size="small"
        type="primary"
        :class="['ch-button-blue',upSource == 'userImage'?'':'maxbut']"
      >
        <span v-if="upSource == 'agentCardPath'">{{ file === null ? '選取代理證' : '重新選擇' }}</span>
        <span v-else-if="upSource == 'weChatQRCode'">{{ file === null ? '選取WeChat二維碼' : '重新選擇' }}</span>
        <span v-else>{{ file === null ? '選取頭像' : '重新選擇' }}</span>
      </el-button>
    </el-upload>

    <div
      class="avatar-cropper-container"
      style="height: 200px; width: 200px"
    >
      <vue-cropper
        ref="cropper"
        :img="file"
        :output-size="option.outputSize"
        :output-type="option.outputType"
        :info="option.info"
        :can-scale="option.canScale"
        :auto-crop="option.autoCrop"
        :auto-crop-width="option.autoCropWidth"
        :auto-crop-height="option.autoCropHeight"
        :fixed-box="option.fixedBox"
        :fixed="option.fixed"
        :fixed-number="option.fixedNumber"
        :can-move="option.canMove"
        :can-move-box="option.canMoveBox"
        :original="option.original"
        :center-box="option.centerBox"
        :info-true="option.infoTrue"
        :full="option.full"
        :enlarge="option.enlarge"
        :mode="option.mode"
        @realTime="realTime"
      />
      <!-- <VueCropper ref="cropper" :img="file" :auto-crop="autoCrop" :auto-crop-height="autoCropHeight" :auto-crop-width="autoCropWidth" :fixed-box="fixedBox" :can-move-box="canMoveBox" :original="canScale" :mode="mode" @realTime="realTime" outputType="png"></VueCropper> -->
    </div>
    <div class="avatar-cropper-change">
      <span class="avatar-cropper-change-text">顯示調節：</span>
      <i
        class="el-icon-circle-plus"
        @click="changeScale(1)"
      />
      <i
        class="el-icon-remove"
        @click="changeScale(-1)"
      />
    </div>
    <!-- 默認頭像展示  点击可剪切-->
    <div
      v-if="upSource == 'userImage'"
      class="default-img"
    >
      <img
        v-for="item in defaultImglist"
        :key="item"
        :src="item"
        @click="chooseDefaultImg(item)"
      >
      <p>可選擇默認頭像</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AvatarCropper',
    computed: {
        ...mapGetters(['userInfo'])
    },
    props: {
        upSource: String,
    },
    data() {
        return {
            option: {
                img: "",
                outputSize: 1, // 裁剪生成图片的质量
                outputType: 'png', // 裁剪生成图片的格式 jpeg, png, webp
                info: true, // 裁剪框的大小信息
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 200, // 默认生成截图框宽度
                autoCropHeight: 200, // 默认生成截图框高度
                fixedBox: true, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [1, 1], // 截图框的宽高比例 [ 宽度 , 高度 ]
                canMove: true, // 上传图片是否可以移动
                canMoveBox: false, // 截图框能否拖动
                original: false, // 上传图片按照原始比例渲染
                centerBox: false, // 截图框是否被限制在图片里面
                infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                full: true, // 是否输出原图比例的截图
                enlarge: '1', // 图片根据截图框输出比例倍数
                mode: 'cover', // 图片默认渲染方式 contain , cover, 100px, 100% auto，
            },
            file: null,
            fileName: null,
            autoCrop: true, // 是否默认生成截图框
            autoCropWidth: 200, // 默认生成截图框宽度
            autoCropHeight: 200, // 默认生成截图框高度
            fixedBox: true, // 是否固定截图框大小
            mode: 'cover',
            autoScale: 1,
            canScale: false,
            canMoveBox: false,
            defaultImglist: []
        };
    },
    created() {
        // 獲取默認圖片
        this.axios.get(this.pub.getApi().GetDefaultUserContactImage).then(res => {
            if (res.data.code == 0 && res.data.result) {this.defaultImglist = res.data.result.images;}
        });
    },
    methods: {
        // 選擇默認圖片
        chooseDefaultImg(data) {
            this.file = data;
            // 圖片name需要帶格式
            let imageFormat = data.match(/((\.png)|(\.jpg)|(\.jpeg))/);
            if (imageFormat) {imageFormat = imageFormat[0];}
            this.fileName = '默認圖片' + new Date().getTime() + (imageFormat || '.jpg');
        },
        beforeAvatarUpload(file) {
            return this.validateFile(file);
        },
        //验证头像格式
        validateFile(file) {
            const isJpg = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpg) {
                this.$message.error('上傳圖片僅支援JPG, JPEG, PNG格式，請重新上傳！');
            }
            return isJpg;
        },
        //选择头像
        changeAvatar(file) {
            if (this.validateFile(file.raw)) {
                this.file = URL.createObjectURL(file.raw);
                let img = new Image();
                img.src = this.file;
                img.onload = () => {
                    // let size = img.naturalHeight > img.naturalWidth ? img.naturalWidth : img.naturalHeight
                    // this.autoCropHeight = size
                    // this.autoCropWidth = size
                };
                this.fileName = file.name;
            }
        },
        resetFile(){
            this.file= null
        },
        canvasColor(file){
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = e => {
                const src = e.target.result
                const image = new Image()
                image.src = src
                image.onload = () => {
                    const canvas = document.createElement('canvas')
                    const width = image.width
                    const height = image.height
                    canvas.width = width
                    canvas.height = height
                    const circle = {
                        x: width / 2,
                        y: height / 2,
                        r: width / 2
                    }
                    const ctx = canvas.getContext('2d')
                    ctx.clearRect(0, 0, width, height)
                    // 在canvas开始绘制前填充白色透明背景并设置透明度，用以清除图片裁剪后透明区域变成黑色的问题
                    ctx.fillStyle = 'rgba(255,255,255, 1)'
                    ctx.fillRect(0, 0, width, height)

                    // 开始路径画圆，剪切处理
                    ctx.save() // 保存当前canvas的状态
                    ctx.beginPath()
                    ctx.arc(circle.x, circle.y, circle.r, 0, Math.PI * 2, false) // 创建弧/曲线(用于创建圆形或部分圆)
                    ctx.clip() // 从原始画布剪切任意形状和尺寸的区域
                    ctx.drawImage(image, 0, 0)
                    ctx.restore() // 返回之前保存过的路径状态和属性，恢复状态
                    canvas.toBlob(blob => {
                            const newFile = new Blob([blob], { type: blob.type });
                            this.$emit('getFileData', newFile, this.fileName);
                            this.$emit('changeDis', false)
                    })
                }
            }
        },

        realTime(data) {
            // 在这给个变量传递给父组件 判断按钮是否禁用 在父组件上加一个自定义事件 传递变量
            if (this.file) {
                this.$refs.cropper.getCropBlob(blobData => {
                    // this.canvasColor(data)
                    // const file = new File([data], this.fileName, { type: data.type });
                    const file = new Blob([blobData], { type: blobData.type });
                    // this.$emit('getFileData', file)
                    this.$emit('getFileData', file, this.fileName);
                    this.$emit('changeDis', false);
                });
            }else{
                this.$emit('changeDis', true);
            }
        },
        changeScale(num) {
            num = num || 1;
            this.$refs.cropper.changeScale(num);
        }
    }
};
</script>

<style scoped lang="less">
.avatar-cropper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .ch-button-blue {
        border: 1px solid rgba(0, 98, 255, 1);
        border-radius: 10px;
        color: #0062ff;
        font-size: 14px;
        font-weight: 400;
        background: #ffffff;
        width: 100px;
    }
    .maxbut{
        width:150px
    }
    .default-img {
        margin-top: 32px;
        img {
            cursor: pointer;
            overflow: hidden;
            border-radius: 6px;
            padding: 12px 6px;
            height: 65px;
            width: 65px;
        }
        p {
            font-size: 12px;
            text-align: center;
        }
    }
    .avatar-cropper-container {
        width: 200px;
        height: 200px;
        margin-top: 20px;
    }

    .avatar-cropper-change {
        display: flex;
        flex-direction: row;
        align-content: stretch;
        margin-top: 15px;

        .avatar-cropper-change-text {
            font-size: 14px;
            font-weight: 400;
            color: rgba(68, 68, 79, 1);
        }

        i {
            font-size: 20px;
            cursor: pointer;
        }

        .el-icon-circle-plus {
            color: rgba(0, 98, 255, 1);
            margin-right: 11px;
        }
    }
}
</style>
